import * as React from 'react';
import Wrapper from '@components/Wrapper';
import * as styles from './style.module.scss';

const {
  postGrid,
  postGrid__content,
  postGrid__sidebar
} = styles;

const PostGrid = ({ content, sidebar }) => {
  return (
    <Wrapper>
      <div className={postGrid}>
        <div className={postGrid__sidebar}>{sidebar}</div>
        <div className={postGrid__content} id="grid-content">
          {content}
        </div>
      </div>
    </Wrapper>
  );
}

export default PostGrid
